import { Form, Spin, Typography } from "antd/es";
import { connect } from "react-redux";
import {
  Button,
  Email,
  Header,
  HorizontalStack,
  Icon,
  Image,
  KCol,
  KPanel,
  KRow,
  Label,
  Password,
  TextInput,
  VerticalStack,
} from "../../components/web-components";
import {
  hideImportMappedExcelModal,
  hideIyzicoDrawer,
  hidePhotoTake,
  hideStripeDrawer,
  showImportMappedExcelModal,
  showIyzicoDrawer,
  showPhotoTake,
  showStripeDrawer,
} from "../../redux/modals/actions";
import { AppState } from "../../redux/root-reducer";
import { KuikaTabOrderProvider } from "../../shared/hoc/tab-order-provider";
import { withContext } from "../../shared/hoc/with-context";
import { withForm } from "../../shared/hoc/with-form";
import { withGoogleLogin } from "../../shared/hoc/with-google-login";
import { withHistory } from "../../shared/hoc/with-history";
import { withInlineOverlayNav } from "../../shared/hoc/with-inline-overlay-nav";
import { withScreenInput } from "../../shared/hoc/with-screen-input";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Signup_ScreenBase } from "./signup-base";

declare let window: any;
const { Title, Paragraph, Text, Link } = Typography;
const menuMap = [];

class Signup_Screen extends Signup_ScreenBase {
  render() {
    if (this.state.isPageVisible === false) {
      return <></>;
    }
    return (
      <>
        <Spin spinning={this.state.spinnerCount > 0}>
          <KuikaTabOrderProvider>
            <Form
              form={this.props.form}
              name="basic"
              initialValues={{
                signup_151658_value: "0b6dc13b-e7ee-45d5-bd8f-e28c68f837cf",
                signup_388216_value: undefined,
                signup_973972_value: undefined,
                signup_298012_value: "",
              }}
              onValuesChange={(changedValues, allValues) => {
                this.clearFieldValidation(changedValues);
              }}
            >
              <div
                style={
                  {
                    display: "flex",
                    flexDirection: "column",
                    minHeight: "100%",
                  } as any
                }
              >
                <Header
                  key="-2"
                  id="signup_header"
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      backgroundColor: "rgba(250, 250, 250, 1)",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "left",
                      paddingTop: 0,
                      paddingRight: 0,
                      paddingBottom: 0,
                      paddingLeft: 0,
                      fontFamily: "Roboto",
                      fontWeight: 400,
                      fontSize: "15px",
                      color: "rgba(34, 30, 30, 1)",
                    } as any
                  }
                >
                  <KRow
                    key="917846"
                    data-testid="Row12"
                    id="917846"
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                      } as any
                    }
                  >
                    <KCol
                      key="880262"
                      data-testid="Col9_1"
                      id="880262"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "center",
                          textAlign: "-webkit-left",
                        } as any
                      }
                    >
                      <Icon
                        key="63335"
                        data-testid="Icon1"
                        id="63335"
                        iconName="arrow_back_ios_new"
                        style={
                          {
                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            borderBottomLeftRadius: 8,
                            borderTopWidth: 1,
                            borderRightWidth: 1,
                            borderBottomWidth: 1,
                            borderLeftWidth: 1,
                            borderColor: "rgba(37, 89, 188, 1)",
                            borderStyle: "solid",
                            paddingTop: 6,
                            paddingRight: 6,
                            paddingBottom: 6,
                            paddingLeft: 6,
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "20px",
                            color: "rgba(37, 89, 188, 1)",
                            letterSpacing: "1px",
                          } as any
                        }
                      ></Icon>
                    </KCol>
                  </KRow>
                </Header>
                <div
                  key="-1"
                  id="signup_body"
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      backgroundColor: "rgba(250, 250, 250, 1)",
                      backgroundImage:
                        "url(" +
                        KuikaAppManager.GetBackendUrl() +
                        "/resource/runtime/byid?resourceId=ad093f83-9518-4e98-9fa4-96b0db348969)",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      backgroundPosition: "bottom",
                      display: "block",
                    } as any
                  }
                >
                  <KRow
                    key="963900"
                    data-testid="Row10"
                    id="963900"
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                        fontFamily: "Roboto",
                        fontWeight: 400,
                        fontSize: "15px",
                        color: "rgba(34, 30, 30, 1)",
                      } as any
                    }
                  >
                    <KCol
                      key="339030"
                      data-testid="Col12_0"
                      id="339030"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 0,
                          paddingRight: 0,
                          paddingBottom: 0,
                          paddingLeft: 0,
                          alignItems: "flex-start",
                          textAlign: "-webkit-center",
                          fontFamily: "Roboto",
                          fontWeight: 400,
                          fontSize: "15px",
                          color: "rgba(34, 30, 30, 1)",
                        } as any
                      }
                    >
                      <KPanel
                        key="754654"
                        data-testid="Panel1"
                        id="754654"
                        scrolling="hidden"
                        scrollRadius={false}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 100,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            maxWidth: "420px",
                            minWidth: "280px",
                            fontFamily: "Roboto",
                            fontWeight: 400,
                            fontSize: "15px",
                            color: "rgba(34, 30, 30, 1)",
                          } as any
                        }
                      >
                        <KRow
                          key="434895"
                          data-testid="Row1_0"
                          id="434895"
                          align="top"
                          justify="start"
                          horizontalGutter={0}
                          verticalGutter={0}
                          style={
                            {
                              borderTopLeftRadius: 12,
                              borderTopRightRadius: 12,
                              borderBottomRightRadius: 12,
                              borderBottomLeftRadius: 12,
                              backgroundColor: "rgba(255, 255, 255, 1)",
                              backgroundRepeat: "no-repeat",
                              backgroundSize: "contain",
                              backgroundPosition: "left",
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "flex-start",
                              textAlign: "-webkit-left",
                              fontFamily: "Roboto",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(34, 30, 30, 1)",
                            } as any
                          }
                        >
                          <KCol
                            key="453834"
                            data-testid="Col3_0"
                            id="453834"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={24}
                            xl={24}
                            xxl={24}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                                fontFamily: "Roboto",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(34, 30, 30, 1)",
                              } as any
                            }
                          >
                            <KRow
                              key="958753"
                              data-testid="Row13"
                              id="958753"
                              align="top"
                              justify="start"
                              horizontalGutter={0}
                              verticalGutter={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 24,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                } as any
                              }
                            >
                              <KCol
                                key="392866"
                                data-testid="Col10_1"
                                id="392866"
                                xs={24}
                                sm={24}
                                md={24}
                                lg={24}
                                xl={24}
                                xxl={24}
                                order={0}
                                pull={0}
                                push={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "flex-start",
                                    textAlign: "-webkit-center",
                                  } as any
                                }
                              >
                                <Form.Item
                                  className="kFormItem"
                                  name="signup_151658_value"
                                >
                                  <Image
                                    key="151658"
                                    data-testid="Image2"
                                    id="151658"
                                    zoomOnClick={false}
                                    imageFit="fit"
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                        height: "42px",
                                        alignItems: "center",
                                        textAlign: "-webkit-left",
                                        display: "inline",
                                        fontFamily: "Roboto",
                                        fontWeight: 400,
                                        fontSize: "15px",
                                        color: "rgba(34, 30, 30, 1)",
                                      } as any
                                    }
                                  ></Image>
                                </Form.Item>
                              </KCol>
                            </KRow>
                            <KRow
                              key="784300"
                              data-testid="Row1_0"
                              id="784300"
                              align="top"
                              justify="start"
                              horizontalGutter={0}
                              verticalGutter={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 24,
                                  paddingRight: 8,
                                  paddingBottom: 24,
                                  paddingLeft: 8,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                  fontFamily: "Roboto",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(34, 30, 30, 1)",
                                } as any
                              }
                            >
                              <KCol
                                key="481500"
                                data-testid="Col3_0"
                                id="481500"
                                xs={24}
                                sm={24}
                                md={24}
                                lg={24}
                                xl={24}
                                xxl={24}
                                order={0}
                                pull={0}
                                push={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 0,
                                    paddingBottom: 0,
                                    paddingLeft: 0,
                                    alignItems: "flex-start",
                                    textAlign: "-webkit-left",
                                    fontFamily: "Roboto",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(34, 30, 30, 1)",
                                  } as any
                                }
                              >
                                <VerticalStack
                                  key="57620"
                                  data-testid="VerticalStack0_0"
                                  id="57620"
                                  direction="vertical"
                                  size={1}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      fontFamily: "Roboto",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(34, 30, 30, 1)",
                                    } as any
                                  }
                                >
                                  <Label
                                    key="717912"
                                    data-testid="lblTitle"
                                    id="717912"
                                    value={ReactSystemFunctions.translate(
                                      this.ml,
                                      717912,
                                      "value",
                                      this.defaultML
                                    )}
                                    writingMode="horizontal"
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                        alignItems: "center",
                                        textAlign: "-webkit-left",
                                        display: "inline",
                                        fontFamily: "Roboto",
                                        fontWeight: 500,
                                        fontSize: "24px",
                                        color: "rgba(34, 30, 30, 1)",
                                      } as any
                                    }
                                  ></Label>
                                  <Label
                                    key="997730"
                                    data-testid="lblSubTitle"
                                    id="997730"
                                    value={ReactSystemFunctions.translate(
                                      this.ml,
                                      997730,
                                      "value",
                                      this.defaultML
                                    )}
                                    writingMode="horizontal"
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                        alignItems: "center",
                                        textAlign: "-webkit-left",
                                        display: "inline",
                                        fontFamily: "Roboto",
                                        fontWeight: 300,
                                        fontSize: "18px",
                                        color: "rgba(129, 131, 132, 1)",
                                      } as any
                                    }
                                  ></Label>
                                </VerticalStack>
                              </KCol>
                            </KRow>
                            <KRow
                              key="836001"
                              data-testid="Row1_1"
                              id="836001"
                              align="top"
                              justify="start"
                              horizontalGutter={0}
                              verticalGutter={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 8,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                  fontFamily: "Roboto",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(34, 30, 30, 1)",
                                } as any
                              }
                            >
                              <KCol
                                key="945778"
                                data-testid="Col3_0"
                                id="945778"
                                xs={24}
                                sm={24}
                                md={24}
                                lg={24}
                                xl={24}
                                xxl={24}
                                order={0}
                                pull={0}
                                push={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 0,
                                    paddingBottom: 0,
                                    paddingLeft: 0,
                                    alignItems: "flex-start",
                                    textAlign: "-webkit-left",
                                    fontFamily: "Roboto",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(34, 30, 30, 1)",
                                  } as any
                                }
                              >
                                <Label
                                  key="635739"
                                  data-testid="Label7"
                                  id="635739"
                                  value={ReactSystemFunctions.translate(
                                    this.ml,
                                    635739,
                                    "value",
                                    this.defaultML
                                  )}
                                  writingMode="horizontal"
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      display: "block",
                                      fontFamily: "Roboto",
                                      fontWeight: 400,
                                      fontSize: "14px",
                                      color: "rgba(155, 155, 155, 1)",
                                      lineHeight: "20px",
                                    } as any
                                  }
                                ></Label>
                                <Form.Item
                                  className="kFormItem"
                                  name="signup_388216_value"
                                >
                                  <TextInput
                                    key="388216"
                                    data-testid="txtName"
                                    id="388216"
                                    kuikaRef={
                                      this.signup_388216_value_kuikaTextInputRef
                                    }
                                    placeholder={ReactSystemFunctions.translate(
                                      this.ml,
                                      388216,
                                      "placeholder",
                                      this.defaultML
                                    )}
                                    allowClear={false}
                                    bordered={true}
                                    disabled={false}
                                    type="text"
                                    iconColor="rgba(0, 0, 0, 1)"
                                    formatter="None"
                                    isCharOnly={false}
                                    autoComplete={true}
                                    inputMode="all"
                                    speechToText={false}
                                    style={
                                      {
                                        borderTopLeftRadius: 12,
                                        borderTopRightRadius: 12,
                                        borderBottomRightRadius: 12,
                                        borderBottomLeftRadius: 12,
                                        borderTopWidth: 1,
                                        borderRightWidth: 1,
                                        borderBottomWidth: 1,
                                        borderLeftWidth: 1,
                                        borderColor: "rgba(246, 246, 246, 1)",
                                        borderStyle: "solid",
                                        backgroundColor:
                                          "rgba(246, 246, 246, 1)",
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        height: "42px",
                                        alignItems: "center",
                                        textAlign: "-webkit-left",
                                        display: "block",
                                        fontFamily: "Roboto",
                                        fontWeight: 400,
                                        fontSize: "15px",
                                        color: "rgba(34, 30, 30, 1)",
                                      } as any
                                    }
                                  ></TextInput>
                                </Form.Item>
                              </KCol>
                            </KRow>
                            <KRow
                              key="269900"
                              data-testid="Row11"
                              id="269900"
                              align="top"
                              justify="start"
                              horizontalGutter={0}
                              verticalGutter={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 8,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                  fontFamily: "Roboto",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(34, 30, 30, 1)",
                                } as any
                              }
                            >
                              <KCol
                                key="136166"
                                data-testid="Col10_0"
                                id="136166"
                                xs={24}
                                sm={24}
                                md={24}
                                lg={24}
                                xl={24}
                                xxl={24}
                                order={0}
                                pull={0}
                                push={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 0,
                                    paddingBottom: 0,
                                    paddingLeft: 0,
                                    alignItems: "flex-start",
                                    textAlign: "-webkit-left",
                                    fontFamily: "Roboto",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(34, 30, 30, 1)",
                                  } as any
                                }
                              >
                                <Label
                                  key="500169"
                                  data-testid="Label10"
                                  id="500169"
                                  value={ReactSystemFunctions.translate(
                                    this.ml,
                                    500169,
                                    "value",
                                    this.defaultML
                                  )}
                                  writingMode="horizontal"
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      display: "block",
                                      fontFamily: "Roboto",
                                      fontWeight: 400,
                                      fontSize: "14px",
                                      color: "rgba(155, 155, 155, 1)",
                                      lineHeight: "20px",
                                    } as any
                                  }
                                ></Label>
                                <Form.Item
                                  className="kFormItem"
                                  name="signup_973972_value"
                                >
                                  <TextInput
                                    key="973972"
                                    data-testid="txtLastname"
                                    id="973972"
                                    kuikaRef={
                                      this.signup_973972_value_kuikaTextInputRef
                                    }
                                    placeholder={ReactSystemFunctions.translate(
                                      this.ml,
                                      973972,
                                      "placeholder",
                                      this.defaultML
                                    )}
                                    allowClear={false}
                                    bordered={true}
                                    disabled={false}
                                    type="text"
                                    iconColor="rgba(0, 0, 0, 1)"
                                    formatter="None"
                                    isCharOnly={false}
                                    autoComplete={true}
                                    inputMode="all"
                                    speechToText={false}
                                    style={
                                      {
                                        borderTopLeftRadius: 12,
                                        borderTopRightRadius: 12,
                                        borderBottomRightRadius: 12,
                                        borderBottomLeftRadius: 12,
                                        borderTopWidth: 1,
                                        borderRightWidth: 1,
                                        borderBottomWidth: 1,
                                        borderLeftWidth: 1,
                                        borderColor: "rgba(246, 246, 246, 1)",
                                        borderStyle: "solid",
                                        backgroundColor:
                                          "rgba(246, 246, 246, 1)",
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        height: "42px",
                                        alignItems: "center",
                                        textAlign: "-webkit-left",
                                        display: "block",
                                        fontFamily: "Roboto",
                                        fontWeight: 400,
                                        fontSize: "15px",
                                        color: "rgba(34, 30, 30, 1)",
                                      } as any
                                    }
                                  ></TextInput>
                                </Form.Item>
                              </KCol>
                            </KRow>
                            <KRow
                              key="339607"
                              data-testid="Row8"
                              id="339607"
                              align="top"
                              justify="start"
                              horizontalGutter={0}
                              verticalGutter={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 8,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                  fontFamily: "Roboto",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(34, 30, 30, 1)",
                                } as any
                              }
                            >
                              <KCol
                                key="662454"
                                data-testid="Col10_0"
                                id="662454"
                                xs={24}
                                sm={24}
                                md={24}
                                lg={24}
                                xl={24}
                                xxl={24}
                                order={0}
                                pull={0}
                                push={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 0,
                                    paddingBottom: 0,
                                    paddingLeft: 0,
                                    alignItems: "flex-start",
                                    textAlign: "-webkit-left",
                                    fontFamily: "Roboto",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(34, 30, 30, 1)",
                                  } as any
                                }
                              >
                                <Label
                                  key="663940"
                                  data-testid="Label11"
                                  id="663940"
                                  value={ReactSystemFunctions.translate(
                                    this.ml,
                                    663940,
                                    "value",
                                    this.defaultML
                                  )}
                                  writingMode="horizontal"
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      display: "block",
                                      fontFamily: "Roboto",
                                      fontWeight: 400,
                                      fontSize: "14px",
                                      color: "rgba(155, 155, 155, 1)",
                                      lineHeight: "20px",
                                    } as any
                                  }
                                ></Label>
                                <Form.Item
                                  className="kFormItem"
                                  name="signup_298012_value"
                                >
                                  <Email
                                    key="298012"
                                    data-testid="txtEmail"
                                    id="298012"
                                    placeholder={ReactSystemFunctions.translate(
                                      this.ml,
                                      298012,
                                      "placeholder",
                                      this.defaultML
                                    )}
                                    allowClear={false}
                                    disabled={false}
                                    iconColor="rgba(0, 0, 0, 1)"
                                    style={
                                      {
                                        borderTopLeftRadius: 12,
                                        borderTopRightRadius: 12,
                                        borderBottomRightRadius: 12,
                                        borderBottomLeftRadius: 12,
                                        borderTopWidth: 1,
                                        borderRightWidth: 1,
                                        borderBottomWidth: 1,
                                        borderLeftWidth: 1,
                                        borderColor: "rgba(246, 246, 246, 1)",
                                        borderStyle: "solid",
                                        backgroundColor:
                                          "rgba(246, 246, 246, 1)",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "contain",
                                        backgroundPosition: "left",
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        height: "42px",
                                        alignItems: "center",
                                        textAlign: "-webkit-left",
                                        display: "block",
                                        fontFamily: "Roboto",
                                        fontWeight: 400,
                                        fontSize: "15px",
                                        color: "rgba(34, 30, 30, 1)",
                                      } as any
                                    }
                                  ></Email>
                                </Form.Item>
                              </KCol>
                            </KRow>
                            <KRow
                              key="335868"
                              data-testid="Row9"
                              id="335868"
                              align="top"
                              justify="start"
                              horizontalGutter={0}
                              verticalGutter={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 8,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                  fontFamily: "Roboto",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(34, 30, 30, 1)",
                                } as any
                              }
                            >
                              <KCol
                                key="842111"
                                data-testid="Col11_0"
                                id="842111"
                                xs={24}
                                sm={24}
                                md={24}
                                lg={24}
                                xl={24}
                                xxl={24}
                                order={0}
                                pull={0}
                                push={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 0,
                                    paddingBottom: 0,
                                    paddingLeft: 0,
                                    alignItems: "flex-start",
                                    textAlign: "-webkit-left",
                                    fontFamily: "Roboto",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(34, 30, 30, 1)",
                                  } as any
                                }
                              >
                                <Label
                                  key="13182"
                                  data-testid="Label12"
                                  id="13182"
                                  value={ReactSystemFunctions.translate(
                                    this.ml,
                                    13182,
                                    "value",
                                    this.defaultML
                                  )}
                                  writingMode="horizontal"
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      display: "block",
                                      fontFamily: "Roboto",
                                      fontWeight: 400,
                                      fontSize: "14px",
                                      color: "rgba(155, 155, 155, 1)",
                                      lineHeight: "20px",
                                    } as any
                                  }
                                ></Label>
                                <Form.Item
                                  className="kFormItem"
                                  name="signup_717714_value"
                                >
                                  <Password
                                    key="717714"
                                    data-testid="txtPassword"
                                    id="717714"
                                    placeholder={ReactSystemFunctions.translate(
                                      this.ml,
                                      717714,
                                      "placeholder",
                                      this.defaultML
                                    )}
                                    disabled={false}
                                    style={
                                      {
                                        borderTopLeftRadius: 12,
                                        borderTopRightRadius: 12,
                                        borderBottomRightRadius: 12,
                                        borderBottomLeftRadius: 12,
                                        borderTopWidth: 1,
                                        borderRightWidth: 1,
                                        borderBottomWidth: 1,
                                        borderLeftWidth: 1,
                                        borderColor: "rgba(246, 246, 246, 1)",
                                        borderStyle: "solid",
                                        backgroundColor:
                                          "rgba(246, 246, 246, 1)",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "contain",
                                        backgroundPosition: "left",
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        height: "42px",
                                        alignItems: "center",
                                        textAlign: "-webkit-left",
                                        display: "block",
                                        fontFamily: "Roboto",
                                        fontWeight: 400,
                                        fontSize: "15px",
                                        color: "rgba(34, 30, 30, 1)",
                                      } as any
                                    }
                                  ></Password>
                                </Form.Item>
                              </KCol>
                            </KRow>
                            <KRow
                              key="896990"
                              data-testid="Row7"
                              id="896990"
                              align="top"
                              justify="start"
                              horizontalGutter={0}
                              verticalGutter={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 8,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                  fontFamily: "Roboto",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(34, 30, 30, 1)",
                                } as any
                              }
                            >
                              <KCol
                                key="858676"
                                data-testid="Col9_0"
                                id="858676"
                                xs={24}
                                sm={24}
                                md={24}
                                lg={24}
                                xl={24}
                                xxl={24}
                                order={0}
                                pull={0}
                                push={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 0,
                                    paddingBottom: 0,
                                    paddingLeft: 0,
                                    alignItems: "flex-start",
                                    textAlign: "-webkit-center",
                                    fontFamily: "Roboto",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(34, 30, 30, 1)",
                                  } as any
                                }
                              >
                                <VerticalStack
                                  key="450803"
                                  data-testid="VerticalStack2"
                                  id="450803"
                                  direction="vertical"
                                  size={1}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      fontFamily: "Roboto",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(34, 30, 30, 1)",
                                    } as any
                                  }
                                >
                                  <Label
                                    key="807378"
                                    data-testid="lblYouAre"
                                    id="807378"
                                    value={ReactSystemFunctions.translate(
                                      this.ml,
                                      807378,
                                      "value",
                                      this.defaultML
                                    )}
                                    writingMode="horizontal"
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 8,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                        alignItems: "center",
                                        textAlign: "-webkit-left",
                                        display: "inline",
                                        fontFamily: "Roboto",
                                        fontWeight: 400,
                                        fontSize: "15px",
                                        color: "rgba(155, 155, 155, 1)",
                                      } as any
                                    }
                                  ></Label>
                                  <HorizontalStack
                                    key="584825"
                                    data-testid="HorizontalStack2"
                                    id="584825"
                                    direction="horizontal"
                                    size={6}
                                    overflowX="auto"
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                        alignItems: "center",
                                        fontFamily: "Roboto",
                                        fontWeight: 400,
                                        fontSize: "15px",
                                        color: "rgba(34, 30, 30, 1)",
                                      } as any
                                    }
                                  >
                                    <Label
                                      key="513929"
                                      data-testid="lnkTermof"
                                      id="513929"
                                      value={ReactSystemFunctions.translate(
                                        this.ml,
                                        513929,
                                        "value",
                                        this.defaultML
                                      )}
                                      writingMode="horizontal"
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          alignItems: "center",
                                          textAlign: "-webkit-left",
                                          display: "inline",
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "16px",
                                          color: "rgba(37, 89, 188, 1)",
                                          lineHeight: "22px",
                                          textDecoration: "underline",
                                        } as any
                                      }
                                    ></Label>
                                    <Label
                                      key="782186"
                                      data-testid="lblAnd"
                                      id="782186"
                                      value={ReactSystemFunctions.translate(
                                        this.ml,
                                        782186,
                                        "value",
                                        this.defaultML
                                      )}
                                      writingMode="horizontal"
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          alignItems: "center",
                                          textAlign: "-webkit-left",
                                          display: "inline",
                                          fontFamily: "Roboto",
                                          fontWeight: 400,
                                          fontSize: "15px",
                                          color: "rgba(155, 155, 155, 1)",
                                        } as any
                                      }
                                    ></Label>
                                    <Label
                                      key="486824"
                                      data-testid="lnkPwPolicy"
                                      id="486824"
                                      value={ReactSystemFunctions.translate(
                                        this.ml,
                                        486824,
                                        "value",
                                        this.defaultML
                                      )}
                                      writingMode="horizontal"
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          alignItems: "center",
                                          textAlign: "-webkit-left",
                                          display: "inline",
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "16px",
                                          color: "rgba(37, 89, 188, 1)",
                                          lineHeight: "22px",
                                          textDecoration: "underline",
                                        } as any
                                      }
                                    ></Label>
                                  </HorizontalStack>
                                </VerticalStack>
                              </KCol>
                            </KRow>
                            <KRow
                              key="268170"
                              data-testid="Row1_2"
                              id="268170"
                              align="top"
                              justify="start"
                              horizontalGutter={0}
                              verticalGutter={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 32,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                  fontFamily: "Roboto",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(34, 30, 30, 1)",
                                } as any
                              }
                            >
                              <KCol
                                key="314356"
                                data-testid="Col3_0"
                                id="314356"
                                xs={24}
                                sm={24}
                                md={24}
                                lg={24}
                                xl={24}
                                xxl={24}
                                order={0}
                                pull={0}
                                push={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 0,
                                    paddingBottom: 0,
                                    paddingLeft: 0,
                                    alignItems: "flex-start",
                                    textAlign: "-webkit-left",
                                    fontFamily: "Roboto",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(34, 30, 30, 1)",
                                  } as any
                                }
                              >
                                <Button
                                  key="387716"
                                  data-testid="btnGetStarted"
                                  id="387716"
                                  onClick={(e?: any) => {
                                    if (e && e.stopPropagation)
                                      e.stopPropagation();
                                    this.SignupComponent_387716_onClick();
                                  }}
                                  showCursorPointer
                                  label={ReactSystemFunctions.translate(
                                    this.ml,
                                    387716,
                                    "label",
                                    this.defaultML
                                  )}
                                  size="middle"
                                  loading={false}
                                  ghost={false}
                                  block={false}
                                  htmlType="button"
                                  iconPosition="left"
                                  danger={false}
                                  style={
                                    {
                                      borderTopLeftRadius: 12,
                                      borderTopRightRadius: 12,
                                      borderBottomRightRadius: 12,
                                      borderBottomLeftRadius: 12,
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      backgroundColor: "rgba(37, 89, 188, 1)",
                                      backgroundRepeat: "no-repeat",
                                      backgroundSize: "contain",
                                      backgroundPosition: "left",
                                      paddingTop: 8,
                                      paddingRight: 16,
                                      paddingBottom: 8,
                                      paddingLeft: 16,
                                      alignItems: "center",
                                      textAlign: "-webkit-center",
                                      display: "block",
                                      fontFamily: "Poppins",
                                      fontWeight: 500,
                                      fontSize: "16px",
                                      color: "rgba(255, 255, 255, 1)",
                                      lineHeight: "22px",
                                    } as any
                                  }
                                ></Button>
                              </KCol>
                            </KRow>
                            <KRow
                              key="81252"
                              data-testid="Row1_3"
                              id="81252"
                              align="top"
                              justify="start"
                              horizontalGutter={0}
                              verticalGutter={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 8,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                  fontFamily: "Roboto",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(34, 30, 30, 1)",
                                } as any
                              }
                            >
                              <KCol
                                key="267559"
                                data-testid="Col3_0"
                                id="267559"
                                xs={24}
                                sm={24}
                                md={24}
                                lg={24}
                                xl={24}
                                xxl={24}
                                order={0}
                                pull={0}
                                push={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 0,
                                    paddingBottom: 0,
                                    paddingLeft: 0,
                                    alignItems: "flex-start",
                                    textAlign: "-webkit-center",
                                    fontFamily: "Roboto",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(34, 30, 30, 1)",
                                  } as any
                                }
                              >
                                <HorizontalStack
                                  key="169602"
                                  data-testid="HorizontalStack0_0"
                                  id="169602"
                                  direction="horizontal"
                                  size={12}
                                  overflowX="auto"
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      alignItems: "center",
                                      fontFamily: "Roboto",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      color: "rgba(34, 30, 30, 1)",
                                    } as any
                                  }
                                >
                                  <Label
                                    key="593542"
                                    data-testid="lblQ"
                                    id="593542"
                                    value={ReactSystemFunctions.translate(
                                      this.ml,
                                      593542,
                                      "value",
                                      this.defaultML
                                    )}
                                    writingMode="horizontal"
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                        alignItems: "center",
                                        textAlign: "-webkit-left",
                                        display: "inline",
                                        fontFamily: "Roboto",
                                        fontWeight: 400,
                                        fontSize: "15px",
                                        color: "rgba(155, 155, 155, 1)",
                                      } as any
                                    }
                                  ></Label>
                                  <Label
                                    key="687615"
                                    data-testid="lnkSignIn"
                                    id="687615"
                                    onClick={(e?: any) => {
                                      if (e && e.stopPropagation)
                                        e.stopPropagation();
                                      this.SignupComponent_687615_onClick();
                                    }}
                                    showCursorPointer
                                    value={ReactSystemFunctions.translate(
                                      this.ml,
                                      687615,
                                      "value",
                                      this.defaultML
                                    )}
                                    writingMode="horizontal"
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                        alignItems: "center",
                                        textAlign: "-webkit-left",
                                        display: "inline",
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "16px",
                                        color: "rgba(37, 89, 188, 1)",
                                        lineHeight: "22px",
                                        textDecoration: "underline",
                                      } as any
                                    }
                                  ></Label>
                                </HorizontalStack>
                              </KCol>
                            </KRow>
                          </KCol>
                        </KRow>
                      </KPanel>
                    </KCol>
                  </KRow>
                </div>
              </div>
            </Form>
          </KuikaTabOrderProvider>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    spinnerCount: state.spinnerReducer.spinnerCount,
    photoTakeVisible: state.photoTakeReducer.visible,
    isImportMappedExcelModalVisible:
      state.importMappedExcelModalReducer.visible,
  };
};
const mapDispatchToProps = (dispatch) => ({
  showPhotoTake: () => dispatch(showPhotoTake()),
  hidePhotoTake: () => dispatch(hidePhotoTake()),
  showStripeDrawer: (data, callback, that, future) =>
    dispatch(showStripeDrawer(data, callback, that, future)),
  hideStripeDrawer: (data, callback, that) =>
    dispatch(hideStripeDrawer(data, callback, that)),
  showIyzicoDrawer: (data, callback, that) =>
    dispatch(showIyzicoDrawer(data, callback, that)),
  hideIyzicoDrawer: (data, callback, that) =>
    dispatch(hideIyzicoDrawer(data, callback, that)),
  showImportMappedExcelModal: (
    dsId,
    tableName,
    primaryKey,
    columnMapping,
    parameters
  ) =>
    dispatch(
      showImportMappedExcelModal(
        dsId,
        tableName,
        primaryKey,
        columnMapping,
        parameters
      )
    ),
  hideImportMappedExcelModal: () => dispatch(hideImportMappedExcelModal()),
});
const tmp = withGoogleLogin(
  withContext(
    withScreenInput(
      withForm(
        withHistory(
          withInlineOverlayNav(
            connect(mapStateToProps, mapDispatchToProps)(Signup_Screen)
          )
        )
      )
    )
  )
);
export { tmp as Signup_Screen };
//export default tmp;
//export { tmp as Signup_Screen };
